import watchSendFeedbackSaga from './sendFeedback';

const feedbackSagas = [watchSendFeedbackSaga()];

export default feedbackSagas;
